import Pagination from 'rc-pagination';
import styled from 'styled-components';
import { mediaMSmMax } from 'helpers/breakpoints';

const PaginationComponent = (props) => {
  const { total, page, perPage = 18, handlePageClick, className } = props;

  const PER_PAGE = perPage;
  const totalPages = Math.ceil(total / PER_PAGE);
  const arrowsEnabled = totalPages > 1;

  const pageNumber = parseInt(page, 10);
  const showLessItems =
    pageNumber < 4 || (pageNumber >= 4 && totalPages <= 7) || (pageNumber >= 5 && pageNumber < totalPages - 3);
  const last2pages = pageNumber === totalPages - 1 || pageNumber === totalPages;

  const itemRender = (current, type, element) => {
    const fourthItemBeforeLast = current === totalPages - 3 && totalPages > 7;
    if (type === 'page') {
      return (
        <a
          className={fourthItemBeforeLast ? 'Pagination-fourthBeforeLast' : ''}
          href="#"
          onClick={(e) => {
            e.preventDefault();
            handlePageClick(current);
          }}
        >
          {current}
        </a>
      );
    }
    if (type === 'prev') {
      return (
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            if (arrowsEnabled) {
              handlePageClick(current);
            }
          }}
        >
          <svg height={32} className="prev NavIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1008 1008">
            <path d="M579 289.1l22.8 21.9c2.4 2.4 4.9 6.3 4.9 10.2 0 3.1-2.4 7.8-4.9 10.2L421.6 503.9l180.2 172.7c2.4 2.4 4.9 7 4.9 10.2 0 3.9-2.4 7.8-4.9 10.2L579 718.8c-2.5 2.3-7.3 4.7-10.6 4.7-4.1 0-8.1-2.3-10.6-4.7L344.1 514.2c-2.4-2.4-4.9-6.3-4.9-10.2 0-3.1 2.4-7.8 4.9-10.2l213.6-204.6c2.5-2.3 6.5-4.7 10.6-4.7 3.3 0 8.2 2.4 10.7 4.6z" />
            <path d="M504 56.5c60.4 0 119 11.8 174.2 35.2 53.3 22.5 101.1 54.8 142.2 95.9 41.1 41.1 73.3 88.9 95.9 142.2 23.3 55.2 35.2 113.8 35.2 174.2s-11.8 119-35.2 174.2c-22.5 53.3-54.8 101.1-95.9 142.2s-88.9 73.3-142.2 95.9C623 939.7 564.4 951.5 504 951.5s-119-11.8-174.2-35.2c-53.3-22.5-101.1-54.8-142.2-95.9-41.1-41.1-73.3-88.9-95.9-142.2C68.3 623 56.5 564.4 56.5 504s11.8-119 35.2-174.2c22.5-53.3 54.8-101.1 95.9-142.2 41.1-41.1 88.9-73.3 142.2-95.9C385 68.3 443.6 56.5 504 56.5zm0 834c52.2 0 102.8-10.2 150.4-30.4 46-19.5 87.4-47.3 122.9-82.8s63.4-76.8 82.8-122.9c20.1-47.6 30.4-98.2 30.4-150.4s-10.2-102.8-30.4-150.4c-19.5-46-47.3-87.4-82.8-122.9s-76.8-63.4-122.9-82.8c-47.6-20.1-98.2-30.4-150.4-30.4s-102.8 10.2-150.4 30.4c-46 19.5-87.4 47.3-122.9 82.8s-63.4 76.8-82.8 122.9c-20.1 47.6-30.4 98.2-30.4 150.4s10.2 102.8 30.4 150.4c19.5 46 47.3 87.4 82.8 122.9s76.8 63.4 122.9 82.8c47.6 20.2 98.2 30.4 150.4 30.4z" />
          </svg>
        </a>
      );
    }
    if (type === 'jump-prev') {
      return <span className="ellipsis">...</span>;
    }
    if (type === 'jump-next') {
      return <span className="ellipsis">...</span>;
    }
    if (type === 'next') {
      return (
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            if (arrowsEnabled) {
              handlePageClick(current);
            }
          }}
        >
          <svg
            height={32}
            data-testid="search-pagination-next-icon"
            className="next NavIcon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1008 1008"
          >
            <path d="M429 718.9L406.1 697c-2.4-2.4-4.9-6.3-4.9-10.2 0-3.1 2.4-7.8 4.9-10.2L586.3 504 406.1 331.4c-2.4-2.4-4.9-7-4.9-10.2 0-3.9 2.4-7.8 4.9-10.2l22.8-21.9c2.5-2.3 7.3-4.7 10.6-4.7 4.1 0 8.1 2.3 10.6 4.7l213.7 204.6c2.4 2.4 4.9 6.3 4.9 10.2 0 3.1-2.4 7.8-4.9 10.2L450.2 718.8c-2.5 2.3-6.5 4.7-10.6 4.7-3.2 0-8.1-2.4-10.6-4.6z" />
            <path d="M504 951.5c-60.4 0-119-11.8-174.2-35.2-53.3-22.5-101.1-54.8-142.2-95.9-41.1-41.1-73.3-88.9-95.9-142.2C68.3 623 56.5 564.4 56.5 504s11.8-119 35.2-174.2c22.5-53.3 54.8-101.1 95.9-142.2s88.9-73.3 142.2-95.9C385 68.3 443.6 56.5 504 56.5s119 11.8 174.2 35.2c53.3 22.5 101.1 54.8 142.2 95.9 41.1 41.1 73.3 88.9 95.9 142.2 23.3 55.2 35.2 113.8 35.2 174.2s-11.8 119-35.2 174.2c-22.5 53.3-54.8 101.1-95.9 142.2-41.1 41.1-88.9 73.3-142.2 95.9-55.2 23.4-113.8 35.2-174.2 35.2zm0-834c-52.2 0-102.8 10.2-150.4 30.4-46 19.5-87.4 47.3-122.9 82.8s-63.4 76.8-82.8 122.9c-20.1 47.6-30.4 98.2-30.4 150.4s10.2 102.8 30.4 150.4c19.5 46 47.3 87.4 82.8 122.9s76.8 63.4 122.9 82.8c47.6 20.1 98.2 30.4 150.4 30.4s102.8-10.2 150.4-30.4c46-19.5 87.4-47.3 122.9-82.8s63.4-76.8 82.8-122.9c20.1-47.6 30.4-98.2 30.4-150.4s-10.2-102.8-30.4-150.4c-19.5-46-47.3-87.4-82.8-122.9s-76.8-63.4-122.9-82.8c-47.6-20.2-98.2-30.4-150.4-30.4z" />
          </svg>
        </a>
      );
    }
    return element;
  };

  return (
    <PaginationWrapper>
      <Pagination
        showLessItems={showLessItems}
        current={parseInt(page, 10)}
        onChange={() => {}}
        defaultCurrent={1}
        total={total}
        pageSize={PER_PAGE}
        className={`Pagination Pagination-current${page} ${className}
        ${page >= totalPages - 3 ? 'Pagination-removePrevious' : ''}
        ${last2pages ? 'Pagination-lastTwo' : ''}
        ${totalPages > 7 ? 'Pagination-moreThanMin' : ''} `}
        showPrevNextJumpers
        // @ts-ignore
        locale="en_US"
        itemRender={itemRender}
        data-testid="components-pagination-box"
      />
    </PaginationWrapper>
  );
};

const PaginationWrapper = styled.div`
  .Pagination {
    padding: 1em 0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    // margin-bottom: 70px;

    &.owner {
      li a {
        color: #0e7873;
      }
      .rc-pagination-prev,
      .rc-pagination-next {
        .NavIcon {
          fill: #0e7873;
        }
      }
    }
    li {
      padding: 0 1em;
      a {
        color: #0751c2;
        cursor: pointer;
      }
    }
    .rc-pagination-item-active {
      a {
        color: #8e9697 !important;
        cursor: inherit;
        pointer-events: none;
      }
    }
    .rc-pagination-prev,
    .rc-pagination-next {
      padding: 0 0.5em;
      .NavIcon {
        fill: #0751c2;
        font-size: 2em;
      }
      &.rc-pagination-disabled {
        a {
          cursor: default;
          opacity: 0.1;
          pointer-events: none;
        }
        .NavIcon {
          fill: #8e9697;
        }
      }
    }
    .ellipsis {
      color: black;
    }
    .disabled {
      color: #dbdfe5;
      pointer-events: none;
    }
  }

  .rc-pagination-options {
    display: none;
  }

  // hack to show desired page items numbers on pagination
  .Pagination-current4.Pagination-moreThanMin {
    .rc-pagination-item-6 {
      display: none;
    }
  }

  .Pagination-removePrevious.Pagination-moreThanMin {
    .rc-pagination-item-after-jump-prev {
      display: none;
    }
  }

  .Pagination-lastTwo.Pagination-moreThanMin {
    .Pagination-fourthBeforeLast {
      opacity: 0;
      visibility: hidden;
      margin-left: -2em;
    }
    .rc-pagination-jump-prev {
      margin-right: -2em;
    }
  }

  ${mediaMSmMax} {
    .Pagination {
      justify-content: space-between;
      flex-wrap: wrap;
      flex-direction: row;
    }
    .Pagination li {
      padding: 0 0.3em;
    }
    .Pagination .rc-pagination-prev,
    .Pagination .rc-pagination-next {
      padding: 0 0.3em;
    }
    .Pagination-lastTwo.Pagination-moreThanMin {
      .Pagination-fourthBeforeLast {
        margin-left: -1.5em;
      }
      .rc-pagination-jump-prev {
        margin-right: -1.5em;
      }
    }
  }
`;

export default PaginationComponent;
